import { Controller } from "@hotwired/stimulus"

// Submits the form it is attached to when a field changes — replaces inline
// onchange/onblur handlers, which the Content Security Policy forbids.
//
//   <form data-controller="autosubmit">
//     <select data-action="change->autosubmit#submit">
//     <input  data-action="blur->autosubmit#submitIfChanged">
export default class extends Controller {
  submit() {
    this.element.requestSubmit()
  }

  // Text fields: only submit when the value differs from what was rendered.
  submitIfChanged(event) {
    const field = event.target
    if (field.value !== field.defaultValue) this.submit()
  }
}
